import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';

const {
  formField: { forProfitCompanyType, businessTypeForProfitOrNonProfit },
} = loanFormModel;

export class ForProfitCompanyTypeValidation implements ValidationSchema {
  public name: string = forProfitCompanyType.name;
  public label = '';
  public dependsOn: string[] = [businessTypeForProfitOrNonProfit.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(
    businessTypeForProfitOrNonProfitValue: string,
    schema: Yup.StringSchema
  ) {
    if (
      forProfitCompanyType.getRequired(businessTypeForProfitOrNonProfitValue)
    ) {
      return schema.required(forProfitCompanyType.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new ForProfitCompanyTypeValidation());
